module.exports = __webpack_public_path__ + "media/src/images/header/logo-17a9e537de22d856f1b78e1e2e5e4c4b.svg";